import config from '../../../Config';
import * as serviceBase from './ServiceBase';
import { getPublicAccessToken, getFormattedUrl } from './utilities';


const API_BASE = config.devMode ? getFormattedUrl(config.formsApiBase) : '/TalentFormsApi/';
const VIDEO_TOKEN_BASE = 'v1/companies/{companyId}/videos/tokens/';
const PUBLIC_VIDEO_TOKEN_BASE = 'v1/public/companies/{companyId}/videos/tokens/';

const GET_VIDEO_CONFIGURATION = API_BASE + 'v1/companies/{companyId}/video/configuration';
const GET_SINGLE_VIEW_TOKEN = API_BASE + VIDEO_TOKEN_BASE + 'view/{videoId}';
const GET_SINGLE_EDIT_TOKEN = API_BASE + VIDEO_TOKEN_BASE + 'edit/{videoId}?employeeId={employeeId}';
const GET_SINGLE_MANAGE_TOKEN = API_BASE + VIDEO_TOKEN_BASE + 'manage/{videoId}';

const PUBLIC_API_BASE = config.devMode ? getFormattedUrl(config.publicFormsApiBase) : getFormattedUrl(window.pctytalentformsexternalgatewaybaseurl) + 'public/';
const PUBLIC_GET_VIDEO_CONFIGURATION = PUBLIC_API_BASE + 'v1/public/companies/{companyId}/video/configuration?publicAccessToken={publicAccessToken}';
const PUBLIC_GET_SINGLE_VIEW_TOKEN = PUBLIC_API_BASE + PUBLIC_VIDEO_TOKEN_BASE + 'view/{videoId}?publicAccessToken={publicAccessToken}';


export async function getVideoConfiguration(companyId, isPublicForm) {

  if (isPublicForm) {
    let publicAccessToken = getPublicAccessToken(companyId, "configuration");
    return await serviceBase.get(PUBLIC_GET_VIDEO_CONFIGURATION, { publicAccessToken, companyId}, !config.devMode==true, undefined, true);
  }
  else {
    return await serviceBase.get(GET_VIDEO_CONFIGURATION, { companyId });
  }
}

export async function getSingleViewToken(companyId, videoId, isPublicForm) {
  if (isPublicForm) {    
    //return an empty string to account for external users not needing a token to view the video
    return '';    
  }
  else {
    return await serviceBase.get(GET_SINGLE_VIEW_TOKEN, { companyId, videoId });
  }
}

export async function getSingleEditToken(companyId, employeeId, videoId) {
  return await serviceBase.get(GET_SINGLE_EDIT_TOKEN, { companyId, employeeId, videoId });
}

export async function getSingleManageToken(companyId, employeeId, videoId) {
  return await serviceBase.get(GET_SINGLE_MANAGE_TOKEN, { companyId, employeeId, videoId });
}
